import { gql, useQuery } from '@apollo/client';

import BaseObligationsTable from './BaseObligationsTable';
import { ObligationsDateFormat } from './BaseObligationsTable';

import type {
  GetUpcomingObligationsForUserQuery,
  GetUpcomingObligationsForUserQueryVariables,
} from './__generated__/UpcomingObligationsTable.gql';
import type { IDateStatus, IObligationsTableRowData } from './BaseObligationsTable';

const GET_UPCOMING_OBLIGATIONS_FOR_USER = gql`
  query GetUpcomingObligationsForUser {
    getUpcomingObligationsForUser {
      ...ObligationsTableRow
    }
  }
  ${BaseObligationsTable.Fragment}
`;

const getUpcomingDateStatus = (row: IObligationsTableRowData): IDateStatus | null => {
  if (row.entityType === 'RecurringTransaction') {
    return { label: 'Expected' };
  }
  if (row.entityType === 'Bill') {
    return { label: 'Due' };
  }
  return null;
};

const UpcomingObligationsTable = () => {
  const { data, loading, error } = useQuery<
    GetUpcomingObligationsForUserQuery,
    GetUpcomingObligationsForUserQueryVariables
  >(GET_UPCOMING_OBLIGATIONS_FOR_USER);

  const rows = data?.getUpcomingObligationsForUser ?? [];

  return (
    <BaseObligationsTable
      title="Upcoming"
      subtitle="In the next 14 days"
      rows={rows}
      dateFormat={ObligationsDateFormat.Relative}
      getDateStatus={getUpcomingDateStatus}
      emptyStateMessage="No upcoming bills or subscriptions due in the next 14 days"
      showChargeSummary={true}
      isLoading={loading}
      hasError={Boolean(error)}
    />
  );
};

export default UpcomingObligationsTable;
